import { useTranslation } from 'react-i18next';

import { getAdministrationRequestApproveNonBillableState } from '@innowise-group/core';
import { Modal, modalHoc, ModalProps } from '@innowise-group/mui-kit';

import * as Styled from './request-non-billable-warning-modal.styles';
import { useMemo } from 'react';
import { localizedNameObject } from '@innowise-group/utilities';
import { useSelector } from 'react-redux';

const RequestNonBillableWarningModal: React.FC<ModalProps> = ({ close }) => {
  const { t } = useTranslation();

  const items = useSelector(getAdministrationRequestApproveNonBillableState);

  const employees = useMemo(() => {
    return (items || []).map((item) => localizedNameObject(item).localizedFullName).join(', ') || '-';
  }, [items]);

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={close}>
        <Styled.ModalTitle>{t('pages.requests.nonBillableWarningModal.requestOnConfirmation')}</Styled.ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Styled.Description>
          <div>{t('pages.requests.nonBillableWarningModal.requestRequireConfirmation', { employees })}</div>
        </Styled.Description>
      </Modal.Body>
      <Styled.Footer>
        <Styled.CloseButton onClick={close} variant="contained">
          {t('buttons.close')}
        </Styled.CloseButton>
      </Styled.Footer>
    </Modal.Container>
  );
};

export default modalHoc(RequestNonBillableWarningModal, 'request-non-billable-warning');
